/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

// eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux
import type { Dispatch } from 'redux';
import type { BatchAction } from 'redux-batched-actions';
import { v4 as uuid } from 'uuid';
import { fg } from '@atlassian/jira-feature-gating';
import { isStableUIEnabledForTests } from '@jira/platform__is-stable-ui-enabled-for-tests/src/isStableUIEnabledForTests.tsx';
import { show } from '../store/constants.tsx';
import type { Action } from '../store/types.tsx';
import { type Flag, toFlagId, type FlagId } from '../types.tsx';

const showFlagService =
	(dispatch: Dispatch<Action | BatchAction>) =>
	(flag: Flag): string | undefined => {
		if (isStableUIEnabledForTests() && fg('jpx-870-stable-ui-for-criterion')) {
			return undefined;
		}

		// Flag is of type FlagComponent
		if (typeof flag === 'function') {
			dispatch(show(flag));
			return undefined;
		}

		const flagId: FlagId = flag.id || toFlagId(uuid());
		const newFlag = {
			...flag,
			id: flagId,
		};

		dispatch(show(newFlag));

		return flagId;
	};

export default showFlagService;
